import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import { AllSectionsView } from "./all-sections-view";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";

export const AllSectionsController = (props) => {
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	useEffect(() => {
		serviceProvider.post("/home?type=setfirstassessmentseen", JSON.stringify({ uid: usid }),true).then((response) => {
			// console.log(response);
		});
	}, []);
	return (
		<>
			<BreadcrumbsItem to="/#my-palnts">My Plants</BreadcrumbsItem>
			<BreadcrumbsItem to="/#your-palnts">Your Plant Name</BreadcrumbsItem>
			<BreadcrumbsItem to="/#all-sections">All Sections</BreadcrumbsItem>
			<AllSectionsView {...props} />
		</>
	);
};
